import { ApiError } from './api';

/**
 * Extract a human-friendly message from an unknown thrown value. The API error
 * body usually carries a NestJS-style `{ message: string | string[] }`; we
 * surface that rather than dumping raw JSON at the user. Falls back to the
 * error's own message, then a generic line.
 */
export function friendlyErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const fromBody = messageFromBody(err.body);
    if (fromBody) return fromBody;
    return err.message;
  }
  if (err instanceof Error) return err.message;
  if (typeof err === 'string' && err.trim()) return err;
  return 'Something went wrong. Please try again.';
}

function messageFromBody(body: unknown): string | null {
  if (!body || typeof body !== 'object') return null;
  const message = (body as { message?: unknown }).message;
  if (typeof message === 'string' && message.trim()) return message;
  if (Array.isArray(message)) {
    const parts = message.filter((m): m is string => typeof m === 'string');
    if (parts.length) return parts.join('. ');
  }
  const error = (body as { error?: unknown }).error;
  if (typeof error === 'string' && error.trim()) return error;
  return null;
}
